import { render, staticRenderFns } from "./AcaoObjetoExecucoesTab.vue?vue&type=template&id=3caf6e8e&scoped=true"
import script from "./AcaoObjetoExecucoesTab.vue?vue&type=script&lang=js"
export * from "./AcaoObjetoExecucoesTab.vue?vue&type=script&lang=js"
import style0 from "./AcaoObjetoExecucoesTab.vue?vue&type=style&index=0&id=3caf6e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caf6e8e",
  null
  
)

export default component.exports